var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8576 10.5972L23.2829 0.190429C22.7848 -0.0634763 22.2155 -0.0634763 21.7147 0.190429L1.14101 10.5972C0.469438 10.9364 0.0259476 11.6829 0.00104225 12.5173C-0.0229892 13.3501 0.370108 14.1281 1.01954 14.52L21.593 26.9646C21.8767 27.1373 22.1876 27.2217 22.4995 27.2217C22.8129 27.2217 23.1234 27.1373 23.4076 26.9646L43.982 14.52C44.6309 14.1281 45.0244 13.3501 45.0008 12.5173C44.9727 11.6829 44.5302 10.9364 43.8576 10.5972Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1683 19.9201L22.4996 31.8208L2.83412 19.9201C1.89266 19.3504 0.726919 19.7546 0.227938 20.8204C-0.274539 21.8858 0.0818553 23.2077 1.02069 23.7759L21.5941 36.2241C21.8778 36.3956 22.1888 36.481 22.5006 36.481C22.814 36.481 23.1246 36.3967 23.4087 36.2241L43.9832 23.7759C44.9198 23.2077 45.2758 21.8858 44.7762 20.8204C44.2734 19.7544 43.1068 19.3502 42.1683 19.9201Z",
    fill: "#8D8BD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1683 28.4428L22.4996 40.3395L2.83412 28.4428C1.89266 27.8726 0.726919 28.2773 0.227938 29.3416C-0.274539 30.407 0.0818553 31.7302 1.02069 32.2976L21.5941 44.7418C21.8778 44.9144 22.1888 44.9999 22.5006 44.9999C22.814 44.9999 23.1246 44.9156 23.4087 44.7418L43.9832 32.2976C44.9198 31.7302 45.2758 30.4072 44.7762 29.3416C44.2734 28.2773 43.1084 27.8724 42.1683 28.4428Z",
    fill: "#57AC2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDetailIcon);
export default __webpack_public_path__ + "static/media/selected-detail-icon.12c296375cfdeb717f5bf89817e18b4d.svg";
export { ForwardRef as ReactComponent };